import PropTypes from 'prop-types';

import { getPax, getDumbPax, paxPropTypes } from './Pax.model';

const getRoom = (index = 1) => ({
  id: index,
  roomCode: '',
  boardCode: '',
  distribution: {
    adults: 1,
    children: 0,
    ages: []
  },
  paxes: [getPax()]
});

const roomPropTypes = {
  id: PropTypes.number,
  roomCode: PropTypes.string,
  boardPlan: PropTypes.string,
  distribution: PropTypes.shape({
    adults: PropTypes.number,
    children: PropTypes.number,
    ages: PropTypes.arrayOf(PropTypes.number)
  }),
  paxes: PropTypes.arrayOf(paxPropTypes)
};

const roomListItemPropTypes = {
  code: PropTypes.string,
  name: PropTypes.string
};

function checkDistributionPaxes (distribution, paxes) {
  if (!distribution) return paxes;

  const { adults, children } = distribution;

  const totalPaxes = paxes.length;
  const totalDist = (adults + children);

  if (!totalPaxes) return paxes;

  if (totalPaxes === totalDist) return paxes;

  const restPaxes = (totalDist - totalPaxes);

  if (restPaxes <= 0) return paxes;

  return [
    ...paxes,
    ...Array.from(Array(restPaxes).keys()).map(() => getDumbPax())
  ];
}

export {
  getRoom,
  roomPropTypes,
  roomListItemPropTypes,
  checkDistributionPaxes
};
